export const dropdownPrefixSelector = 'pm-dropdown';

export const DropdownMenuSharedCssClassName = {
	SUBMENU: `${dropdownPrefixSelector}-submenu`,
};
